export default "__VITE_PUBLIC_ASSET__d51c1c4b__"